module.exports = __webpack_public_path__ + "media/images/icons/check-green-97fe9d22889219f1ffff5c313bdd11cd.svg";